export default "__VITE_ASSET__CPF1fcTt__"